import { render, staticRenderFns } from "./LogDescription.vue?vue&type=template&id=7222f191"
import script from "./LogDescription.vue?vue&type=script&lang=js"
export * from "./LogDescription.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports